export enum EStarRating {
  NoRating = 0,
  Star1 = 1,
  Star2 = 2,
  Star3 = 3,
  Star4 = 4,
  Star5 = 5,
}
